<div class="table-responsive line-items">
  <table class="table mb-0 mb-md-5">
    <thead>
      <th>
        <span>
          {{ 'document-view-public.document-view-items.service-item' | translate }}
        </span>
      </th>
      <th
        [class.text-center]="document.type !== 'write-off'"
        [class.text-right]="document.type === 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.quantity' | translate }}
        </span>
      </th>
      <th
        class="text-center"
        *ngIf="
          document['hasUnit'] && document.type !== 'write-off'
        "
      >
        <span>
          {{ 'document-view-public.document-view-items.unit' | translate }}
        </span>
      </th>
      <th
        class="text-center"
        *ngIf="document.type !== 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.price' | translate }}
        </span>
      </th>
      <th
        class="text-center"
        *ngIf="!!document.totalDiscount && document.type !== 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.discount' | translate }}
        </span>
      </th>
      <th
        class="text-center"
        *ngIf="!!document['_documentTaxes']?.length && document.type !== 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.tax' | translate }}
        </span>
      </th>
      <th
        class="text-right"
        *ngIf="document.total !== document.totalWithTax && document.type !== 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.total-tax' | translate }}
        </span>
      </th>
      <th
        class="text-right"
        *ngIf="document.type !== 'write-off'"
      >
        <span>
          {{ 'document-view-public.document-view-items.total' | translate }}
        </span>
      </th>
      <th
        class="text-right"
        *ngIf="
          document.type !== 'write-off' &&
          document.total !== document.totalWithTax &&
          !document._documentClient.taxSubject
        "
      >
        <span>
          {{ 'document-view-public.document-view-items.total-with-tax' | translate }}
        </span>
      </th>
    </thead>

    <tbody
      class="border-bottom"
      *ngFor="let item of document._documentItems"
      [item]="item"
      [document]="document"
      [locale]="locale"
      app-document-view-item
    >
    </tbody>

  </table>
</div>
